import React, { useEffect, useState } from "react";

import { getUserBoard } from "../../services/user.service";
import EventBus from "../../common/EventBus";
import LastPriceTable from "./table";
import useLastPriceStatusPolling from "../../hooks/useLastPriceStatusPolling";

const BoardLast = (props) => {
  const [content, setContent] = useState({});

  // Silent background polling to keep Lastprice DAG status refreshed.
  useLastPriceStatusPolling();

  useEffect(() => {
    getUserBoard().then(
      (response) => {
        setContent(response.data);
      },
      (error) => {
        setContent(
          (error.response &&
            error.response.data &&
            error.response.data.message) ||
            error.message ||
            error.toString()
        );

        if (error.response && error.response.status === 401) {
          EventBus.dispatch("logout");
        }
      }
    );
  }, []);

  return (
    <div className="flex flex-col justify-center items-center w-full">
      {content.comp === "MyTable" ? <LastPriceTable isad={props.isad} /> : null}
    </div>
  );
};

export default BoardLast;
